var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    shapeRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    textRendering: "geometricPrecision",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#26008A;}\n\t.st1{fill:#FFFFFF;stroke:#13008A;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,22.1 148.3,27.9 148.3,197.1 150,198.8 228.5,152.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,22.1 71.4,152.4 150,198.8 150,116.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,213.7 149,214.8 149,275.1 150,277.9 228.6,167.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,277.9 150,213.7 71.4,167.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150,198.8 228.5,152.4 150,116.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "71.4,152.4 150,198.8 150,116.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.0ada34656ff9295196ba8ff35049b46b.svg";
export { ForwardRef as ReactComponent };